import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import FabAdd from "../../components/FabAdd";
import API from '../../utils/api';
import { getCurrentOrg } from "../../utils/operations.js";
import { observer, inject } from "mobx-react";

const isStripeIntegrated = org =>
  org.stripe_publishable_key && org.stripe_secret_key && org.stripe_webhook_secret;

const Organisations = ({ Auth, history }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!Auth.can('organisations')) { history.push("/children"); return; }
    API.get(getCurrentOrg).then(res => setData(res.data.resource));
  }, []);

  return (
    <div style={{ maxWidth: 400, margin: "auto" }}>
      <List>
        <h3>Schools</h3>
        {data.map(row => (
          <ListItem
            sx={{ border: '1px solid lightgrey', borderRadius: '10px', marginBottom: '10px', cursor: 'pointer' }}
            key={row.id}
            onClick={() => history.push("/editorganisations/" + row.id)}
          >
            <div>
              <p style={{ color: '#212121', fontWeight: 'bold' }}>{row.name}</p>
              <p>{row.address}<br />{row.city + ", " + row.st}</p>
              {isStripeIntegrated(row)
                ? <p style={{ color: '#4caf50' }}>Stripe Configured</p>
                : <p style={{ color: '#f44336' }}>Stripe Not Configured</p>}
            </div>
          </ListItem>
        ))}
      </List>
      <FabAdd onClick={() => history.push("/neworganisations")} />
    </div>
  );
};

export default inject("Auth")(observer(Organisations));

